import { render, staticRenderFns } from "./AutoRewardsSplash.vue?vue&type=template&id=413a88a0"
import script from "./AutoRewardsSplash.vue?vue&type=script&lang=js"
export * from "./AutoRewardsSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports